import env from '@beam-australia/react-env';

const CONFIG = {
    IMG_PROXY_URL: 'https://img.apetit.io/apetitio',
    IMG_EXT: '.jpg'
};

export function getImgProxyUrl() {
    return env('IMG_PROXY_URL') || CONFIG.IMG_PROXY_URL;
}

export const ImgExt = CONFIG.IMG_EXT;

export default getImgProxyUrl();
